import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';
import { getValueByLanguage } from '../../utils';

const BuyGroupItem = ({ group }) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const l = useCallback(
        (text) => {
            return getValueByLanguage(text, i18n.language);
        },
        [i18n.language],
    );
    const handleSelectTicket = () => {
        navigate('group-ticket', { state: { group: group } });
    };
    return (
        <div onClick={handleSelectTicket} className={styles.wrapper}>
            <div className={styles.groupContent}>
                <p className={styles.groupName}>{l(group.groupName)}</p>
                <div className={styles.groupSubtitle}>{l(group.groupSubtitle)}</div>
            </div>
        </div>
    );
};

export default BuyGroupItem;
